export default __webpack_public_path__ + "static/media/baby-kids.2186b78b.png";